import { render } from "./App.vue?vue&type=template&id=36606f8c"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=36606f8c&lang=css"

import exportComponent from "/home/nicky/htdocs/vuejs-tailwindcss-project/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__